import { useCallback, useState } from 'react';

import useSendFileToS3PreSignedPostUrlCallback from './useSendFileToS3PreSignedPostUrlCallback';
import usePreSignedUrlPostUploadCallback from './usePreSignedUrlPostUploadCallback';

export function useUploadFilesToS3Callback(
  filesProgress,
  setFileProgress,
  onEndLoad = () => { return false; }
) {
  const [loading, setLoading] = useState(false);
  const {
    callback: preSignedUrlUploadCallback
  } = usePreSignedUrlPostUploadCallback();

  const {
    callback: sendFileToS3PreSignedUrlCallback
  } = useSendFileToS3PreSignedPostUrlCallback();
  const callback = useCallback(async ({ files }) => {
    try {
      setLoading(true);
      const uploadedFiles = await Promise.all(
        files.map(async (file) => {
          const {
            url,
            fields
          } = await preSignedUrlUploadCallback({
            fileKey: file.fileKey,
            headers: {
              'content-type': file.type
            }
          });
          await sendFileToS3PreSignedUrlCallback({
            file,
            url,
            fields,
            onUploadProgress: (progressEvent, requestInstance) => {
              const total = Math.round((progressEvent.loaded / progressEvent.total) * 100);
              setFileProgress({
                ...file,
                meta: {
                  requestInstance,
                  progress: total
                }
              });
            }
          });
          return file;
        })
      );
      onEndLoad();
      setLoading(false);
      return uploadedFiles;
    } catch (error) {
      setLoading(false);
      throw error;
    }
  }, [onEndLoad, preSignedUrlUploadCallback, sendFileToS3PreSignedUrlCallback, setFileProgress]);

  const removeFile = useCallback((file) => {
    if (
      filesProgress[file.key]
      && filesProgress[file.key].meta
      && filesProgress[file.key].meta.requestInstance
      && filesProgress[file.key].meta.progress < 100
    ) {
      filesProgress[file.key].meta.requestInstance.abort('Upload aborted');
    }
  }, [filesProgress]);
  return {
    callback,
    loading,
    filesProgress,
    removeFile
  };
}

export default useUploadFilesToS3Callback;
